import React from 'react';
import { Callback as CallbackPage } from '@jupiter/react-common-component';
import { useAuth } from 'react-oidc-context';

const Callback = () => {
  const { isAuthenticated, isLoading } = useAuth();
  return (
    <>
      <CallbackPage isAuthenticated={isAuthenticated} isLoading={isLoading} />
    </>
  );
};

export default Callback;
